import { render, staticRenderFns } from "./VisitReportView.vue?vue&type=template&id=2978f481&scoped=true"
import script from "./VisitReportView.vue?vue&type=script&lang=js"
export * from "./VisitReportView.vue?vue&type=script&lang=js"
import style0 from "./VisitReportView.vue?vue&type=style&index=0&id=2978f481&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2978f481",
  null
  
)

export default component.exports